import BaseScreen from "../BaseScreen";
import NavBar from "../../components/NavBar";
import { CommonSetting } from "../../components/setting/CommonSetting";
import { MainNavProps } from "../navigation/main/MainParamList";
import React, { useEffect, useState } from "react";
import {
  Modal,
  Platform,
  SafeAreaView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { otherText } from "../../net/service";
import * as ImSdk from "../../../imsdk/api";
import {
  color_333333,
  color_3C3C3C,
  ColorRed,
} from "../../assets/style/colors";
import { showDialog } from "../../components/CommonDialog";
import { hideLoading, showLoading } from "../../components/Loading";
import { showToast } from "../../components/Toast";
import {
  Str_AboutApp,
  Str_Cancel,
  Str_ChatMsgIsNull,
  Str_CleanAllChatMsg,
  Str_CleanAllDialogLoading,
  Str_CleanAllDialogMsg,
  Str_CleanFail,
  Str_CleanSuc,
  Str_ClearCache,
  Str_Confirm,
  Str_Feedback,
  Str_Help,
  Str_LanguageSwitching,
  Str_OtherSetting,
  Str_SignOut,
  Str_TingTongText,
  Str_Tip,
  Str_Version,
} from "../../language/string_res";
import { clearCache, getCacheSize } from "../../utils/FileUtils";
import { ButtonView } from "../../components/ButtonView";
import { changeLanguage } from "../../language/i18n";
import { CommonModal } from "../../components/CommonModal";
export const ChangeLanguageModal = ({
  visible,
  close,
}: {
  visible: boolean;
  close: () => void;
}) => {
  // 切换语言的函数
  const changeLng = (lng: string) => {
    close();
    changeLanguage(lng);
  };
  //日本语 英语 葡萄牙语 越南语
  return (
    <Modal
      visible={visible}
      animationType={"fade"}
      transparent={true}
      statusBarTranslucent={true}
      onRequestClose={close}
    >
      <TouchableOpacity
        style={{ flex: 1, backgroundColor: "rgba(0,0,0,0.5)" }}
        activeOpacity={1}
        onPress={close}
      >
        <SafeAreaView
          style={{
            position: "absolute",
            width: "90%",
            maxWidth: 500,
            alignSelf: "center",
            backgroundColor: "white",
            borderRadius: 16,
            bottom: 20,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.25,
            shadowRadius: 8,
            elevation: 8,
          }}
        >
          <ButtonView
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingVertical: 18,
            }}
            onPress={() => changeLng("en")}
            textStyle={{ fontSize: 18, color: color_333333 }}
            text="English"
          />
          <View
            style={{
              backgroundColor: "#F1F1F1",
              height: 0.5,
              marginHorizontal: 9,
            }}
          />
          <ButtonView
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingVertical: 18,
            }}
            onPress={() => changeLng("ja")}
            textStyle={{ fontSize: 18, color: color_333333 }}
            text="日本語"
          />
          <View
            style={{
              backgroundColor: "#F1F1F1",
              height: 0.5,
              marginHorizontal: 9,
            }}
          />
          <ButtonView
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingVertical: 18,
            }}
            onPress={() => changeLng("vi")}
            textStyle={{ fontSize: 18, color: color_333333 }}
            text="Việt Nam"
          />
          <View
            style={{
              backgroundColor: "#F1F1F1",
              height: 0.5,
              marginHorizontal: 9,
            }}
          />
          <ButtonView
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingVertical: 18,
            }}
            onPress={() => changeLng("es")}
            textStyle={{ fontSize: 18, color: color_333333 }}
            text="España"
          />
          <View
            style={{
              backgroundColor: "#F1F1F1",
              height: 0.5,
              marginHorizontal: 9,
            }}
          />
          <ButtonView
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingVertical: 18,
            }}
            onPress={() => changeLng("pt")}
            textStyle={{ fontSize: 18, color: color_333333 }}
            text="Portugal"
          />
          <View
            style={{
              backgroundColor: "#F1F1F1",
              height: 0.5,
              marginHorizontal: 9,
            }}
          />
          <ButtonView
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingVertical: 18,
            }}
            onPress={() => changeLng("zh")}
            textStyle={{ fontSize: 18, color: color_333333 }}
            text="中文"
          />
          <View
            style={{
              backgroundColor: "#F1F1F1",
              height: 0.5,
              marginHorizontal: 9,
            }}
          />
          <View style={{ backgroundColor: "#F7F7F7", height: 6 }} />
          <ButtonView
            style={{
              alignItems: "center",
              justifyContent: "center",
              paddingVertical: 16,
            }}
            onPress={close}
            textStyle={{ fontSize: 18, color: ColorRed }}
            text={Str_Cancel}
          />
        </SafeAreaView>
      </TouchableOpacity>
    </Modal>
  );
};
export const OtherSetting = ({ navigation }: MainNavProps<"OtherSetting">) => {
  const packageJson = require("../../../package.json");
  const versionCode = packageJson.version;
  const [version, setVersion] = useState("");
  const [versionUrl, setVersionUrl] = useState("");
  const [help, setHelp] = useState("");
  const [helpUrl, setHelpUrl] = useState("");
  const [cleanVisible, setCleanVisible] = useState(false);
  const [langVisible, setLangVisible] = useState(false);
  const [cacheSize, setCacheSize] = useState("");

  useEffect(() => {
    Promise.all([otherText(1), otherText(2)]).then(([r1, r2]) => {
      if (r1.data && r1.data.text) {
        setHelp(r1.data.text);
      }
      if (r1.data && r1.data.url) {
        setHelpUrl(r1.data.url);
      }
      if (r2.data && r2.data.text) {
        setVersion(r2.data.text);
      }

      if (r2.data && r2.data.url) {
        setVersionUrl(r2.data.url);
      }
    });
  }, []);

  useEffect(() => {
    getCache();
  }, []);

  function getCache() {
    getCacheSize().then((size) => {
      setCacheSize(`${(size / 1024 / 1024).toFixed(2)} MB`);
    });
  }
  const clean = () => {
    setCleanVisible(false);
    showLoading(Str_CleanAllDialogLoading);
    const im = ImSdk.getInstance();
    im.CleanAllMsg()
      .then((value) => {
        if (value.code === 1) {
          showToast(Str_ChatMsgIsNull);
        }
        if (value.code != -1) {
          showToast(Str_CleanSuc);
          im.emit("topic_refresh", {});
        } else {
          showToast(Str_CleanFail);
        }
      })
      .finally(() => {
        hideLoading();
      });
  };

  const ClearCache = () => {
    showLoading();
    clearCache()
      .then(() => {
        hideLoading();
      })
      .finally(() => {
        hideLoading();
        getCache();
      });
  };

  return (
    <BaseScreen>
      <NavBar showBack={Platform.OS !== "web"} title={Str_OtherSetting} />
      <View style={styles.contentContainer}>
        <CommonSetting
          style={{ marginTop: 12, borderRadius: 0 }}
          itemOption={[
            /// 1.5.3 需求删除帮助入口
            // {
            //     text: Str_Help,
            //     onClick: () => {
            //         if (helpUrl && helpUrl.length > 0) {
            //             navigation.navigate('CommonWeb', { title: Str_Help, url: helpUrl, showBack: true })
            //         }
            //     },
            //     rightType: "Back",
            // },
            {
              text: Str_AboutApp,
              rightType: versionUrl && versionUrl.length > 0 ? "Back" : "None",
              onClick: () => {
                if (versionUrl && versionUrl.length > 0) {
                  navigation.navigate("CommonWeb", {
                    title: Str_AboutApp,
                    url: versionUrl,
                    showBack: true,
                  });
                }
              },
              rightText: `${Str_Version}${versionCode}`,
            },
            // {
            //   text: Str_Feedback,
            //   rightType: "Back",
            //   onClick: () => {
            //     navigation.navigate("Feedback");
            //   },
            // },
            {
              text: Str_CleanAllChatMsg,
              onClick: () => {
                setCleanVisible(true);
              },
              rightType: "Back",
            },
            {
              text: Str_ClearCache,
              onClick: ClearCache,
              rightText: cacheSize,
              rightType: "Back",
            },
            {
              text: Str_LanguageSwitching,
              onClick: () => setLangVisible(true),
              rightType: "Back",
            },
          ]}
        />
      </View>
      <CommonModal
        title={Str_Tip}
        content={Str_CleanAllChatMsg}
        cancelText={Str_Cancel}
        confirmText={Str_Confirm}
        visible={cleanVisible}
        onConfirm={clean}
        onClose={() => setCleanVisible(false)}
      />
      <ChangeLanguageModal
        visible={langVisible}
        close={() => setLangVisible(false)}
      />
    </BaseScreen>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    width: "100%",
    maxWidth: 800,
    alignSelf: "center",
    paddingHorizontal: 20,
    marginTop: 40,
    backgroundColor: "white",
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    paddingTop: 8,
    paddingBottom: 8,
  },
});
